import { trpc } from '@tencent/tpro_rmonitor_web_server_basic';
import { get } from 'lodash-es';
import { getUserId } from '@/infrastructure/auth';
import { BusiCode } from '@/infrastructure/axios/code';
import AbstractHttpClient from '@/infrastructure/axios/request';
import { logger } from '@/infrastructure/logger';
import { getProductId, getTagCapitalPlatform, isHarmonyOS } from '@/infrastructure/product-info';
import { formatTags } from '@/presentation/components/question-tag/api';
import { Platform } from '@/proto/field';
import { TrpcService } from '@/service/trpc';
import { WithTypeCast } from '@raft/utils';
import IBatchBindTagReq = trpc.rmonitor.web_server.IBatchBindTagReq;
import IBindTagRsp = trpc.rmonitor.web_server.IBindTagRsp;
type IGetUserCustomReq = WithTypeCast<trpc.rmonitor.web_server.IGetUserCustomReq>;
type IUserCustom = WithTypeCast<trpc.rmonitor.web_server.IUserCustom>;
type IGetTagReq = WithTypeCast<trpc.rmonitor.web_server.IGetTagReq>;
type IGetTagRsp = WithTypeCast<trpc.rmonitor.web_server.IGetTagRsp>;
type IBindTagReq = WithTypeCast<trpc.rmonitor.web_server.IBindTagReq>;
type IMonitorFieldDistinctDataReq = WithTypeCast<trpc.rmonitor.web_server.IMonitorFieldDistinctDataReq>;


export type TagInfo = {
  tagId: string;
  tagName: string;
  tagColor: string;
};

export type ITag = WithTypeCast<trpc.rmonitor.web_server.ITag>;;

export class BasicService extends AbstractHttpClient {
  constructor() {
    super({
      serviceName: TrpcService.BasicService,
    });
  }

  public async getMonitorFieldDistinctData(req: IMonitorFieldDistinctDataReq): Promise<string[]> {
    try {
      const res = await this.trpcPost('GetMonitorFieldDistinctData', req);

      return get(res, 'data', []);
    } catch (e) {
      return [];
    }
  }

  public async getUserCustom(req: IGetUserCustomReq): Promise<IUserCustom[]> {
    try {
      const res = await this.trpcPost('GetUserCustom', req);

      return get(res, 'userCustom', []);
    } catch (e) {
      return [];
    }
  }

  /**
   * 详情页获取标签接口
   * @param params
   */
  public async getTagByFeature(req: IGetTagReq) {
    try {
      const data: IGetTagRsp = await this.trpcPost('GetTagByFeature', req);
      return {
        versions: {
          maxAppVersion: data?.maxAppVersion ?? '',
          minAppVersion: data?.minAppVersion ?? '',
        },
        tags: formatTags(data.tags ?? []),
      };
    } catch (e) {
      logger.error(`GetTagByFeature:${e}`);
    }
    return {
      versions: { maxAppVersion: '', minAppVersion: '' },
      tags: [],
    };
  }

  public async  bindTagToFeature(params: IBindTagReq): Promise<boolean> {
    try {
      const platform = getTagCapitalPlatform();
      await this.trpcPost('BindTagToFeature', {
        productId: getProductId(),
        platform: isHarmonyOS() ? Platform.Harmony : platform,
        user: getUserId(),
        ...params,
      });
      return true;
    } catch (e) {
      logger.error(`AddTag:${e}`);
    }
    return false;
  };

  // 批量绑定标签
  public async  batchBindTagToFeature(params: IBatchBindTagReq): Promise<boolean> {
    try {
      const platform = getTagCapitalPlatform();
      const res = await this.trpcPost<IBindTagRsp>('BatchBindTagToFeature ', {
        productId: getProductId(),
        platform: isHarmonyOS() ? Platform.Harmony : platform,
        ...params,
      });
      return res.baseRsp?.code === BusiCode.Ok;
    } catch (e) {
      logger.error(`AddTag:${e}`);
    }
    return false;
  };
}

export const basicService = new BasicService();
